import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";

import { history } from "../../utils/History";
import { isSafeListReturnPath } from "../../utils/listQueryState";
import { toastError } from "../../components/commons/toast";
import Promo from "../../store/actions/promotion/Index";
import WinnerReview from "./WinnerReview";

const GenerateWinnerResult = ({ match }) => {
  const promotionId = match?.params?.id_promo;
  const location = useLocation();
  const dispatch = useDispatch();
  const generatedWinners = location.state?.newData;
  const [promo, setPromo] = useState();
  const participantPath = `/promo-participant/${promotionId}`;
  const requestedReturnTo = location.state?.returnTo;
  const backPath = isSafeListReturnPath(requestedReturnTo, participantPath)
    ? requestedReturnTo
    : `${participantPath}${location.search}`;

  useEffect(() => {
    if (!Array.isArray(generatedWinners)) {
      toastError("Hasil generate tidak tersedia.");
      history.replace(backPath);
      return;
    }

    new Promise((resolve) => {
      dispatch(Promo.detail({ id: promotionId }, resolve));
    }).then((response) => setPromo(response?.data));
  }, [backPath, dispatch, generatedWinners, promotionId]);

  if (!Array.isArray(generatedWinners)) return null;

  return (
    <WinnerReview
      promotionId={promotionId}
      promo={promo}
      winners={generatedWinners}
      isLoading={!promo}
      backPath={backPath}
    />
  );
};

export default GenerateWinnerResult;
